export const timelineTemplate = {
    "timelineField": {},
    "timelineAddlFields": [],
    "sortOrder": "ASC",
    "lines": [],
    "display": "LIST",
    "tableElevation": 2,
    "showSwitch": true,
    "expandMonth": true,
    "expandDay": true,
    "showMonthCount": true,
    "showDayCount": true,
    "emptyStateMessage": "No data available"
  }